import Hero from "../components/Hero";
import HeroImage from "../../assets/images/Calculator1.jpg";
import mortgageCalculatorImage from "../../assets/images/Calculator2.jpg";
import Accordion from "../designSystem/Accordion";
import { ReactComponent as EquityIcon } from "../../assets/icons/Equity_Release.svg";
import { ReactComponent as HowMuchCanIBorrowIcon } from "../../assets/icons/How_Much_can_I_Borrow.svg";
import { ReactComponent as HowMuchWillItCostIcon } from "../../assets/icons/How_Much_it_will_Cost.svg";
import { ReactComponent as InheritanceTaxIcon } from "../../assets/icons/Inheritance_Tax.svg";
import { ReactComponent as InvestmentIcon } from "../../assets/icons/Investment.svg";
import { ReactComponent as MortgageBorrowIcon } from "../../assets/icons/Mortgage_Borrow.svg";
import { ReactComponent as MortgageRepaymentIcon } from "../../assets/icons/Mortgage_Repayment.svg";
import { ReactComponent as OverpaymentIcon } from "../../assets/icons/Overpayment.svg";
import { ReactComponent as PensionsShortfallIcon } from "../../assets/icons/Pensions_Shortfall.svg";
import { ReactComponent as RelevantLifeIcon } from "../../assets/icons/Relevent_life_Tax.svg";
import { ReactComponent as StampDutyIcon } from "../../assets/icons/StampDuty.svg";
import FeatureCards from "../designSystem/FeatureCards";
import { useNavigate } from "react-router-dom";

const CalculatorsPage = () => {
  const navigate = useNavigate();
  const calculators = [
    {
      title: "Mortgage Borrow",
      icon: MortgageBorrowIcon,
      description: "",
      onClick: () => navigate("/mortgage-borrow"),
    },
    {
      title: "Mortgage Repayment",
      icon: MortgageRepaymentIcon,
      description: "",
      onClick: () => navigate("/mortgage-repayment"),
    },
    {
      title: "Overpayment",
      icon: OverpaymentIcon,
      description: "",
      onClick: () => navigate("/overpayment"),
    },
    {
      title: "Stamp Duty",
      icon: StampDutyIcon,
      description: "",
      onClick: () => navigate("/stamp-duty"),
    },
    {
      title: "How Much Will It Cost",
      icon: HowMuchWillItCostIcon,
      description: "",
      onClick: () => navigate("/how-much-will-it-cost"),
    },
    {
      title: "How Much Can I Borrow",
      icon: HowMuchCanIBorrowIcon,
      description: "",
      onClick: () => navigate("/how-much-can-i-borrow"),
    },
    {
      title: "Equity Release",
      icon: EquityIcon,
      description: "",
      onClick: () => navigate("/equity-release"),
    },
    {
      title: "Relevant Life Tax",
      icon: RelevantLifeIcon,
      description: "",
      onClick: () => navigate("/relevant-life-tax"),
    },
  ];
  return (
    <div className="home-page">
      <Hero
        title="Calculators"
        titleAlign="center"
        backgroundImage={HeroImage}
        rightImage={HeroImage}
        subtitleAlign="center"
        lightOverlay={true}
      />
      <section className="grey-container">
        <div className="grey-container-content">
          <div className="row">
            <div className="content-column">
              <h2 className="burgandy align-left">Our Calculators</h2>
              <div className="divider burgandy align-left" />
              <div className="content grey align-left">
                Explore our range of easy to use calculators designed to help
                you plan and understand your finances. Whether you want to
                estimate how much you could borrow, your monthly repayments,
                associated costs, or potential savings, simply enter your
                details and adjust the options to see how different factors may
                affect your results.
              </div>
              <div className="content-semibold grey align-left">
                Please note: Results are a guide only. Actual payments will vary
                depending on the lender, product, and fees such as stamp duty.
              </div>
            </div>
            <img
              src={mortgageCalculatorImage}
              alt="WPP Financial Services Building"
              className="image-container"
            />
          </div>
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content"></div>
      </section>
      <section className="grey-container">
        <div className="grey-container-content">
          <FeatureCards features={calculators} />
        </div>
      </section>
      <section className="white-container">
        <div className="white-container-content">
          <div className="column">
            <h2 className="burgandy">Important Information</h2>
            <div className="divider burgandy" />
            <Accordion title="What to Consider">
              <ul>
                <li>
                  Affordability: Make sure you can comfortably afford repayments
                </li>
                <li>
                  Interest Changes: Check how payments could change if rates
                  rise (e.g. by 3%)
                </li>
                <li>
                  Additional Costs: Include fees such as stamp duty, legal
                  costs, and surveys
                </li>
              </ul>
            </Accordion>
            <Accordion title="Key Inputs Explained">
              <ul>
                <li>Property Price – The value of the home you want to buy</li>
                <li>
                  Deposit – The amount you can put down upfront (a larger
                  deposit can mean better rates)
                </li>
                <li>
                  Loan to Value (LTV) – The percentage of the property value you
                  borrow
                </li>
                <li>
                  Term – How long you repay the mortgage (typically 25–40 years)
                </li>
                <li>
                  Interest Rate – The cost of borrowing, which affects your
                  monthly payments
                </li>
              </ul>
            </Accordion>
            <Accordion title="Repayment Mortgage">
              Pay both the loan and interest each month, gradually reducing the
              balance.
            </Accordion>
            <Accordion title="Interest-Only Mortgage">
              Pay only the interest monthly. You must have a plan in place to
              repay the loan at the end of the term.
            </Accordion>
            <Accordion title="Important">
              <ul>
                <li>This calculator provides estimates only</li>
                <li>Always check full product details before committing</li>
                <li>
                  Your home may be repossessed if you do not keep up repayments
                </li>
              </ul>
            </Accordion>
          </div>
        </div>
      </section>

      {/* <section className="white-container">
        <div className="white-container-content"></div>
      </section> */}
    </div>
  );
};

export default CalculatorsPage;
